export class StoreConsumptionRequest{
    storeConsumptionId : number;
    
    constructor(storeConsumptionId : number)
    {
        this.storeConsumptionId = storeConsumptionId;
        
    }
}
